import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { fetchMe, logout as apiLogout } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // The admin session lives in a secure HttpOnly cookie sent automatically
    // by the browser — no token is read or stored by the frontend.
    fetchMe()
      .then((u) => {
        setUser(u);
        if (u?.session_exp) localStorage.setItem("vessel_session_exp", String(u.session_exp));
      })
      .catch(() => {
        localStorage.removeItem("vessel_session_exp");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const signInSession = useCallback((u, sessionExp) => {
    if (sessionExp) localStorage.setItem("vessel_session_exp", String(sessionExp));
    setUser(u);
    return u;
  }, []);

  const signOut = useCallback(async () => {
    try { await apiLogout(); } catch (e) { console.warn("logout request failed, clearing local session:", e); }
    localStorage.removeItem("vessel_session_exp");
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, ready, signInSession, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
